var wishlistFilterTemplate = {
    // Grid Template
  	'soldOutClass': 'sold-out-wishlist',
    'productGridItemHtml': '<div class="grid__item product-block product-{{productIdClass}} {{soldOutClass}} flex column {{maxColsClass}} min-cols-2 {{itemGridWidthClass}}">' +
                              '<div class="wishlist_products card-wrapper">'+                                  
                                  '<div class="image">' +
                                      '<div class="inner">' +
                                          '<a href="{{itemUrl}}">' +
                                              '{{itemImg}}' +
                                           '</a>' +
                                          '{{itemQuickView}}' +
                                       '</div>' +
                                  '</div>' +

                                  '<div class="card-information">' +
                                      '<div class="card-information__wrapper">' +
  										  '<span class="jdgm-widget jdgm-preview-badge" data-id="{{ pID }}" data-template="collection" data-auto-install="false"></span>'+
                                          '<span class="product-reviews-badge" data-id="{{ pID }}"></span>' +   
                                          '{{itemcomingsoon}}' +
                                          '{{itemeverydaybestbuy}}' +
  										  '<div class="card__badge">'+
                                            '{{itemSoldOut}}'+
                                            '{{itemSale}}'+
                                            '{{fastDispatch}}'+
                                          '</div>'+
                                          '<a class="card-information__text h5" href="{{itemUrl}}">{{itemTitle}}</a>' +
                                          '<div class="price {{saleClass}}">{{itemPrice}}</div>' +
                                          '<div class="below-image">'+
  											  '{{WishlistClose}}' +
                                              '<button class="btn move_to_cart" data-product="{{productId}}" data-producthandle="{{productHandle}}" data-id="{{ variantID }}">'+
  											  	'<svg width="40" height="40" viewBox="0 0 40 40"><g id="boost-pfs-icon-cart" transform="scale(0.03125 0.03125)"><path d="M448.217 818.845c-56.377 0-102.256 45.902-102.256 102.256 0 56.377 45.879 102.256 102.256 102.256s102.256-45.879 102.256-102.256c0-56.379-45.857-102.256-102.256-102.256zM448.217 977.908c-31.312 0-56.807-25.472-56.807-56.807 0-31.312 25.495-56.807 56.807-56.807s56.807 25.495 56.807 56.807c0.003 31.335-25.472 56.807-56.807 56.807z"></path><path d="M768.66 818.845c-56.377 0-102.256 45.902-102.256 102.256 0 56.377 45.879 102.256 102.256 102.256 56.354 0 102.256-45.879 102.256-102.256 0-56.379-45.902-102.256-102.256-102.256zM768.66 977.908c-31.335 0-56.807-25.472-56.807-56.807 0-31.312 25.472-56.807 56.807-56.807 31.29 0 56.807 25.495 56.807 56.807 0.003 31.335-25.517 56.807-56.807 56.807z"></path><path d="M1019.164 259.373c-4.294-5.499-10.886-8.702-17.883-8.702h-768.3l-63.329-233.255c-0.137-0.5-0.5-0.886-0.682-1.364-0.5-1.476-1.25-2.773-2.046-4.090-0.749-1.25-1.431-2.477-2.385-3.545-0.931-1.068-2.021-1.865-3.159-2.726-1.182-0.909-2.317-1.795-3.659-2.454-1.25-0.637-2.591-0.953-3.975-1.364-1.476-0.431-2.907-0.794-4.476-0.909-0.545-0.022-1.001-0.319-1.568-0.319h-124.978c-12.543 0-22.724 10.181-22.724 22.724s10.181 22.724 22.724 22.724h107.595l63.239 232.959 113.572 460.078c2.499 10.156 11.612 17.293 22.065 17.293h558.448c10.452 0 19.543-7.112 22.065-17.293l113.617-460.282c1.7-6.796 0.154-13.955-4.162-19.476zM869.871 710.976h-522.865l-102.39-414.858h727.667l-102.413 414.858z"></path></g></svg>'+
  												'<span>Move To Cart</sapn>'+
  											  '</button>' +
                                              '<button style="display:none;" class="btn out_of_stock">{{ noAddToCart }}</button>'+
                                          '</div>' +
                                      '</div>' +
                                  '</div>' +
                              '</div>'+
                          '</div>'

};

var bvwishlist = getwishlistCookie('bvwishlist');
if (bvwishlist == undefined || bvwishlist == ''){
  
  setwishlistCookie('bvwishlist', JSON.stringify({"items": []}), {expires: 365});
}

var bvwishlist = getwishlistCookie('bvwishlist');
var bvwishlist_json = JSON.parse(bvwishlist);
var bv_customer_id = jQuery('#ms_customer_id').val();
function bvwishlist_count() {
  var bvwishlist = getwishlistCookie('bvwishlist');
  var bvwishlist_json = JSON.parse(bvwishlist);
  if (bvwishlist_json.items.length > 0) {
    jQuery('.bvwishcount').html(bvwishlist_json.items.length);
  } else {
    jQuery('.bvwishcount').html('');
  }
  if (bvwishlist_json.items.length > 0) {
    jQuery('.bvwishcountheader').html('<span>'+bvwishlist_json.items.length+'</span');
  } else {
    jQuery('.bvwishcountheader').html('');
  }
}
var productExists = function (items, product_variant) {
    for (var i = 0; i < items.length; i++) {
      if ((items[i][0] == product_variant[0])){
        return i;
      }
    }
    return -1;
}

jQuery('body').on('click', '.move_to_wishlist', function (e) {
  var $this = $(this);
  var lineItemID = $this.attr('data-line_id');
  var postData = jQuery.post('/cart/change.js', {
    line: lineItemID,
    quantity: 0
  })
  postData.complete(function() {
    var product_id = $this.attr('data-pid'); //product id
    var variant_id = $this.attr('data-vid'); //variant id
    var product_handle = $this.attr('data-producthandle'); //product handle
    if(window.customerId){
      saveWishlistItemToDb(variant_id,product_id,product_handle,window.customerId,window.customerEmail);
    }  
    saveDataToCookie(variant_id,product_id,product_handle);
    location.reload();
  });
  
});

jQuery(document).ready(function(){


jQuery('body').on('click', '.move_to_cart', function (e) {
  var $this = $(this);
  var pid = $this.attr('data-id');
  jQuery.post('/cart/add.js', {
    id: pid,
    quantity: 1
  })
  .complete(function(data) {
    var product_id = $this.attr('data-product'); //product id
  	var product_handle = $this.attr('data-producthandle');
    if(window.customerId){
	    removeWishlistItemToDb(product_id,window.customerId);
    }
    removeDataFromCookie(product_id,product_handle,pid);   
    updateCartSummariesnew(true);
  })
  .fail(function(data) {
  	  console.log(data['responseText']);
  });
});
});
var shopifyAjaxStorePageURLnew = '/search';
var updateCartSummariesnew = function(showCartSummary) {
  var xMsgText = $('#mini-cart-shipping-savings-message').text();
  var xMsgHTML = $('#mini-cart-shipping-savings-message').html();
  $.get(shopifyAjaxStorePageURLnew, function(data){
    var selectors = ['.custom-info .current-cart', '#cart-summary'];
    var $parsed = $($.parseHTML('<div>' + data + '</div>'));

    for(var i=0; i<selectors.length; i++) {
      var cartSummarySelector = selectors[i];
      var $newCartObj = $parsed.find(cartSummarySelector).clone();
      var $currCart = $(cartSummarySelector);
      $currCart.replaceWith($newCartObj);

    }
    if(showCartSummary) {
      $('body').addClass('show-cart-summary');
    }

  });
}
var noiteminwishlist = function() {
  var bvwishlist = getwishlistCookie('bvwishlist');
  var bvwishlist_json = JSON.parse(bvwishlist);
  if(bvwishlist_json.items.length == 0){
    jQuery(".wishlistitemsgrid").html('<div class="nowishlist">There is no Wishlist item!</div>');
    jQuery('.bvwishcountheader').html('');
  }
}
jQuery(document).ready(function(){


jQuery('body').on('click', '.wishlistitem a, a.wishlistclose', function (e) {
  e.preventDefault();
  var $this = jQuery(this);
  var product_id = jQuery(this).data('product'); //product id
  var variant_id = jQuery(this).data('variant'); //variant id
  var product_handle = jQuery(this).data('producthandle'); //product handle
  
  if (product_id != 0) {
    
    var product_variant = [product_id, 1, product_handle,variant_id];
    if ($this.attr("data-status") == "active") //remove
    {
      if(window.customerId){
        removeWishlistItemToDb(product_id,window.customerId);
      }
      
      if($this.hasClass('wishlistclose')){
        $this.parents('.product-block').slideUp(1000, 'swing', function(){
          $this.parents('.product-block').remove();
        });
        
        //$this.parents('.product-block').remove();
      }
      $this.attr('data-status', '');
      
	  var bvwishlist = getwishlistCookie('bvwishlist');
	  var bvwishlist_json = JSON.parse(bvwishlist);
      
      bvwishlist_json.items.splice(productExists(bvwishlist_json.items, product_variant), 1);
      setwishlistCookie('bvwishlist', JSON.stringify(bvwishlist_json), {expires: 365});
      bvwishlist_count();
      noiteminwishlist();
      //wishlist_save();
    } else {  //add
      if(window.customerId){
        saveWishlistItemToDb(variant_id,product_id,product_handle,window.customerId,window.customerEmail);
      }

      $this.attr('data-status', 'active');
      
      var bvwishlist = getwishlistCookie('bvwishlist');
	  var bvwishlist_json = JSON.parse(bvwishlist);
      
      bvwishlist_json.items.push(product_variant);
      setwishlistCookie('bvwishlist', JSON.stringify(bvwishlist_json), {expires: 365});
      bvwishlist_count();
      //wishlist_save();
    }
  }

});  
});
jQuery(document).ready(function(){


if(jQuery(".wishlistitemsgrid").length > 0){
  noiteminwishlist();
  jQuery.each(bvwishlist_json.items, function(index, value) {
    producthandle = value[2];
    if($('.product-'+value[0]).length < 1){
    	getwishproducts(producthandle,index);
    }
  });
}
});
function getwishproducts(producthandle, index){
  if($('.nowishlist').length > 0){
  	$(".nowishlist").remove();
  }
    var $producturl = window.location.origin+'/products/'+producthandle;
	
  	jQuery.getJSON($producturl+'.js', function (result) {
      
    }).done(function (data) {
      //data = result.product;
      var itemHtml = wishlistFilterTemplate.productGridItemHtml;
      var images = data.images;
      var onSale = data.variants[0].compare_at_price > data.variants[0].price;
      
      var soldOut = !(data.available);
      if(!(data.available)){
        itemHtml = itemHtml.replace(/{{ noAddToCart }}/g, "Out of Stock");
      }
      var comming = false;
      for(var i = 0; i <data.tags.length; i++) {
        if(data.tags[i] == 'instore'){
        	soldOut = true;
          	itemHtml = itemHtml.replace(/{{ noAddToCart }}/g, "Instore Only");
          	break;
        }
        if(data.tags[i] == 'coming-soon'){
          comming = true;
        }
      }
      var installementText = '';
      
      var CP = data.variants[0].price/100;
      if (CP > 200 && CP < 6001) {
        var emi = ((CP)/52);
        var with2Decimals = emi.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
        installementText += '<span class="installement">or pay $'+ with2Decimals +' per week.*';
      }

      if (CP < 200){
        var emi = ((CP)/5);
        var with2Decimals = emi.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
        installementText += '<span class="installement">or pay $'+with2Decimals +' per fortnight.*';
      }
      
      var $wishlistclose = '<a data-status="active" data-product="{{productId}}" class="wishlistclose" href="javascript:void();"><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="trash-alt" class="svg-inline--fa fa-trash-alt fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"></path></svg>Remove</a>';
      itemHtml = itemHtml.replace(/{{WishlistClose}}/g, $wishlistclose);
      itemHtml = itemHtml.replace(/{{productId}}/g, data.id);
      itemHtml = itemHtml.replace(/{{productHandle}}/g, data.handle);
      
        // Coming soon
      itemHtml = itemHtml.replace(/{{itemcomingsoon}}/g, buildcomingsoon(data));
      // every day best buy
      itemHtml = itemHtml.replace(/{{itemeverydaybestbuy}}/g, buildeverydaybestbuy(data));

      // Add maxColsClass
      itemHtml = itemHtml.replace(/{{maxColsClass}}/g, 'max-cols-4');
	  var soldOutClass = soldOut ? wishlistFilterTemplate.soldOutClass : '';
      if(soldOut){
      	itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, '<span class="badge badge--bottom-left color-accent-2" aria-hidden="true">Sold out</span>');
      }
      itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, '');
      
      if(!soldOut){
        if($.inArray('FastDelivery', data.tags) != -1){
        	itemHtml = itemHtml.replace(/{{fastDispatch}}/g, '<span data-skafos-similar-fast_delivery><span class="fastdispatch badge badge--bottom-left color-accent-2" aria-hidden="true">Fast Dispatch</span><span>');
        }
      }
      itemHtml = itemHtml.replace(/{{fastDispatch}}/g, '');
      
      if (onSale && !soldOut) {
        itemHtml = itemHtml.replace(/{{itemSale}}/g, '<span class="badge badge--bottom-left color-accent-2" aria-hidden="true">Sale</span>');
      }
      itemHtml = itemHtml.replace(/{{itemSale}}/g, '');
      
      itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
      var itemGridWidthClass = ''
      if (index % 2 == 1) { itemGridWidthClass += 'nth-2 '; }
      if (index % 3 == 1) { itemGridWidthClass += 'nth-3 '; }
      if (index % 4 == 1) { itemGridWidthClass += 'nth-4 '; }
      if (index % 6 == 1) { itemGridWidthClass += 'nth-6 '; }
      itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

      // Add Block layout class
      var blockLayoutClass = 'above';
      itemHtml = itemHtml.replace(/{{blockLayoutClass}}/g, blockLayoutClass);

      // Add price
      var itemPriceHtml = '';
      var saleClass = '';
      itemPriceHtml += '<span class="amount">$' + (data.variants[0].price/100) + '</span>';
      if (onSale) {
          itemPriceHtml += ' <del>$' + (data.variants[0].compare_at_price/100) + '</del>';
      }
      
      if(comming == true){
      	itemPriceHtml = installementText = '';
      }
      
      itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
      itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
      itemHtml = itemHtml.replace(/{{ pID }}/g, data.id);
      itemHtml = itemHtml.replace(/{{ variantID }}/g, data.variants[0].id);
      itemHtml = itemHtml.replace(/{{installementText}}/g, installementText);
      
      var itemImgHtml = '';
      var aspect_ratio = '';
      if(typeof images[0] !== "undefined") {
          aspect_ratio = images[0]['width'] / images[0]['height'];
      }
      
      var itemQuickViewHtml = '';
      button = 'Quick View';
      if (1 == 1) {
          itemQuickViewHtml += '<div class="quick-buy-wrap pos-middle" style="">';
          itemQuickViewHtml += '<a class="quick-buy ';
          itemQuickViewHtml += 'giant';
          itemQuickViewHtml += '-round-button" href="{{itemUrl}}">' + button + '</a>';
          itemQuickViewHtml += '</div>';
      }
      //itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);
      itemHtml = itemHtml.replace(/{{itemQuickView}}/g, '');
      
      var cover = false;
      var img_src = "https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif";
      if(typeof images[0] !== "undefined") {
        img_src = images[0];
      }
      itemImgHtml += '<div class="reveal">';
      itemImgHtml +=  '<div class="rimage-outer-wrapper">' +
                          '<div class="rimage-wrapper lazyload--placeholder">' +
        '<img style="width:100%;" class="rimage__image lazyload fade-in" src="' + img_src + '" ' +
                                  'data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="' + aspect_ratio + '" ' +
                                  'data-sizes="auto" alt="{{itemTitle}}"' +
                              '/>' +
                          '</div>' +
                      '</div>' +
                      '<noscript>' +
                          '<img src="' + img_src + ' alt="{{itemTitle}}" class="rimage__image"/>' +
                      '</noscript>';
      if (images.length > 1) {
          itemImgHtml += '<img class="hidden" src="' + images[1] + '" alt="{{itemTitle}}" />' ;
      }
      itemImgHtml += '</div>';
      itemHtml = itemHtml.replace(/{{itemImg}}/g, itemImgHtml);
      itemHtml = itemHtml.replace(/{{productIdClass}}/g, data.id);
      itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
      itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
      itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
      itemHtml = itemHtml.replace(/{{itemUrl}}/g, $producturl);

      jQuery('.wishlistitemsgrid').append(itemHtml);
    });
}

function buildeverydaybestbuy(data){
  var htmlbadge = "";
  htmlbadge += '<div class="best-buy">';
  if(data.tags) {
    if($.inArray('best-buy',data.tags) >= 0){
      htmlbadge += '<div class="every-day-best-buy"><p>'+theme.settings.best_buy_tag_text+'</p></div>';
    }
  }
  htmlbadge += '</div>';
  return htmlbadge;
}

function buildcomingsoon(data){
  var htmlbadge = "";
  htmlbadge += '<div class="coming-soon-badge">';
  if(data.tags) {
    if($.inArray('coming-soon',data.tags) >= 0){
      htmlbadge += '<div class="sale" style="background: '+theme.settings.comingsoon_badge_bg_color+'; color: '+theme.settings.comingsoon_badge_text_color+';">'+theme.settings.comingsoon_badge+'</div>';
    }
  }
  htmlbadge += '</div>';
  return htmlbadge;
}

var $checkitemload = setInterval(function () {
  if(jQuery(".wishlistitem").length > 0){
	updateWishlist();
    clearInterval($checkitemload);
  }
}, 100);
setInterval(updateWishlist, 3000);
function updateWishlist() {
  jQuery(".wishlistitem").each(function (i) {
    var bvwishlist = getwishlistCookie('bvwishlist');
	var bvwishlist_json = JSON.parse(bvwishlist);
    var $this = jQuery(this);
    var product_id = $this.find('a').attr('data-product'); //product id
    var product_variant = [product_id, 0];
    if (productExists(bvwishlist_json.items, product_variant) > -1) { //add
      $this.find('a').attr('data-status', 'active');
      
    } else {
      $this.find('a').attr('data-status', '');
    }
  });
}
function setwishlistCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + "; SameSite=none; Secure; path=/";
}

function getwishlistCookie(cname) {
  var name = decodeURIComponent( unescape( unescape(cname + "=")));
  
  var decodedCookie = decodeURIComponent( unescape( unescape(document.cookie)) );
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

jQuery(document).ready(function() {
  
  if(window.customerId){
    var pathname = window.location.pathname;   
    
    if(pathname == "/pages/wishlist"){
      getwishlistFromDB();
    }
    if(window.userLoggedIn && window.userLoggedIn == "1"){
     	var bvwishlist = getwishlistCookie('bvwishlist');
		var bvwishlist_json = JSON.parse(bvwishlist);
      $.get( AGScriptTag.api_url+"/save_watchwishlist_all",
      { 
        wishlist_data: bvwishlist_json, 
        customer_id: window.customerId,
        email: window.customerEmail,
      })
      .done(function( data ) {
       // window.userLoggedIn == "done";
      });
    }
  }
});


function getwishlistFromDB() { 
  
  setwishlistCookie('bvwishlist', JSON.stringify({"items": []}), {expires: 365});
  $.get( AGScriptTag.api_url+"/watchwishlist/"+window.customerId)
      .done(function( data ) {
      	var bvwishlist = getwishlistCookie('bvwishlist');
		var bvwishlist_json = JSON.parse(bvwishlist);
        for (i = 0; i < data.length; i++) {  
          var product_variant = [data[i].product_id, 1, data[i].product_handle];
          bvwishlist_json.items.push(product_variant);
        }
    	setwishlistCookie('bvwishlist', JSON.stringify(bvwishlist_json), {expires: 365});
    	bvwishlist_count();
    
    	var bvwishlist = getwishlistCookie('bvwishlist');
		var bvwishlist_json = JSON.parse(bvwishlist);
    
    	jQuery.each(bvwishlist_json.items, function(index, value) {
          if($('.product-'+value[0]).length < 1){
            producthandle = value[2];
            getwishproducts(producthandle,index);
          }
        });
  });
}

function saveWishlistItemToDb(variant_id, product_id,product_handle,customer_id,customerEmail){
  $.get( AGScriptTag.api_url+"/save_watchwishlist",
      { 
        product_id: product_id,
    	variant_id: variant_id,
        product_handle: product_handle,
        customer_id: customer_id,
        email: customerEmail,
      })
      .done(function( data ) {
        	return true;
      });
}

function removeWishlistItemToDb(product_id,customer_id){
  $.get( AGScriptTag.api_url+"/remove_from_watchwishlist/"+product_id+"/"+customer_id)
      .done(function( data ) {
    //console.log("removed from db");
        return true;
      });
}

function saveDataToCookie(variant_id,product_id,product_handle){

	var bvwishlist = getwishlistCookie('bvwishlist');
  	var bvwishlist_json = JSON.parse(bvwishlist);
  
    var product_variant = [product_id, 1, product_handle,variant_id];            
    bvwishlist_json.items.push(product_variant);
    setwishlistCookie('bvwishlist', JSON.stringify(bvwishlist_json), {expires: 365});
    bvwishlist_count();
}

function removeDataFromCookie(product_id,product_handle,variant_id){
    var product_variant = [product_id, 1, product_handle,variant_id];  
  	var bvwishlist = getwishlistCookie('bvwishlist');
    var bvwishlist_json = JSON.parse(bvwishlist);
    bvwishlist_json.items.splice(productExists(bvwishlist_json.items, product_variant), 1);
    setwishlistCookie('bvwishlist', JSON.stringify(bvwishlist_json), {expires: 365});
    bvwishlist_count();
  	$('.product-'+product_id).slideUp(1000, 'swing', function(){
          $('.product-'+product_id).remove();
    });
  	noiteminwishlist();
}
